import { Tag } from '@workwave-tidal/core/components'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export function TagValue(props: Props) {
  const { children } = props

  return <Tag mode="rounded" label={children} />
}
